import React, { useState } from "react"

//CSS
import {head} from "./languageBar.module.css"
import {languageBar} from "./languageBar.module.css"
import {form} from "./languageBar.module.css"
import {input} from "./languageBar.module.css"
import {label} from "./languageBar.module.css"
import {checekd} from "./languageBar.module.css"


import getLanguage from "../utilt/getLangueage"


const LanguageBar = (props) => {
    const [lang, setLang] = useState(getLanguage() || props.lang || "en");
    return (
        <div
            className={head}
        >
            <div
                className={languageBar}
            >
                <form className={form}>
                    <input
                        id="En"
                        value="en"
                        type="radio"
                        onChange={() => {
                            if (typeof window !== 'undefined') {
                                localStorage.setItem("site_Language", "en");
                                setLang("en");
                                props.setLang("en");
                            }
                        }}
                        checked={typeof window !== 'undefined' ? lang !== "ja" : false}
                        className={input}
                    >
                    </input>
                    <label
                        htmlFor="En"
                        className={lang !== "ja" ? `${label} ${checekd}` : label}
                        title={lang === "ja" ? `英語` : `English`}
                    >
                        En
            </label>
                    <input
                        id="Jp"
                        value="ja"
                        type="radio"
                        onChange={() => {
                            if (typeof window !== 'undefined') {
                                localStorage.setItem("site_Language", "ja");
                                setLang("ja");
                                props.setLang("ja");
                            }
                        }}
                        checked={typeof window !== 'undefined' ? lang === "ja" : false}
                        className={input}
                    >
                    </input>
                    <label
                        htmlFor="Jp"
                        className={lang === "ja" ? `${label} ${checekd}` : label}
                        title={lang === "ja" ? `日本語` : `Japanese`}
                    >
                        Jp
            </label>
                </form >
            </div>

        </div>
    )
}

export default LanguageBar;